import React from "react";
import { licenseFields } from "../../utils/utils";
import Card from "../shared/Card";
import FormField from "./utilComponents/FormField";
import FormButton from "../shared/FormButton";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { license } from "../../features/auth/actions/auth";
import LoginWrapper from "../hoc/LoginWrapper";

const licenseSchema = Yup.object().shape({
  license: Yup.string().min(3).max(45).required("This field is required")
});

const License = () => {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.auth.loading);

  return (
    <Card>
      <div className="mb-8">
        <div className="font-bold text-lg">License Expired</div>
      </div>
      <Formik
        initialValues={{
          license: ""
        }}
        validationSchema={licenseSchema}
        onSubmit={(values) => dispatch(license(values))}
      >
        {() => (
          <Form>
            {licenseFields.map((field) => (
              <FormField key={field.name} {...field} />
            ))}
            <FormButton isSubmitting={loading} buttonText="Submit" />
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default LoginWrapper(License);
